import { DisplayProperties } from '@com-delta-idp/mnx-skymiles-shared';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import { EntryItem } from '@com-delta-omnichannel/aura';
import { StatusType } from './snapshot.types';

export interface Amounts {
  base: string;
  miles: string;
  segments: string;
  dollars: string;
}

export interface Activity {
  date: string;
  name: string;
  balance?: string;
  status?: StatusType;
  amounts: Partial<Amounts>;
}

export interface Snapshot extends DisplayProperties {
  title: string;
  toggle: EntryItem;
  activities: EntryItem[];
  action: Link;
}
